module.exports = __webpack_public_path__ + "img/about_introduce.247c5ea2.png";